<template>
  <div v-if="invalid == false" class="main_container">
    <h3>Loading...</h3>
    <p>Verifying your link...</p>
  </div>
  <div v-else class="main_container">
    <h3>Error</h3>
    <p>
      The link you followed is invalid or has expired. Please contact your
      representative for a new link.
    </p>
  </div>
</template>

<script>
function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}
function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}
import $ from "jquery";
export default {
  name: "VerifyBankLeadLoading",
  components: {},
  props: {
    link: String,
  },
  data() {
    return {
      invalid: false,
    };
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    doubleNext() {
      this.$emit("doublenext", this.$data);
    },
  },
  mounted: function () {
    var self = this;
    console.log("mounted verify lead loading");
    const leadId = getWithExpiry("leadid");
    let leadid_url = this.link;
    if (leadId) {
      console.log("found lead in memory :D");
      self.next();
      self.invalid = false;
      return false;
    }
    if (leadId && this.link == "oauth") {
      leadid_url = leadId;
    }

    $.ajax({
      type: "POST",
      url: "/api/bank-verification/verify-bank-lead-link",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ link: leadid_url }),
    })
      .done(function (response) {
        console.log("verify link response");
        console.log(response);
        if (response.valid && response.valid == true) {
          setWithExpiry("first_name", response.first_name, 259200);
          self.next();
          self.invalid = false;
        } else {
          setWithExpiry("first_name", null, 1);
          self.next();
          self.invalid = true;
        }
      })
      .fail(function (err) {
        console.log("fail");
        console.log(err.responseText);
        self.invalid = true;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_container {
  padding-top: 64px;
  margin-left: 8%;
  margin-right: 8%;
  height: 70vh;
}
</style>
